export const en = {
  // Navigation
  "nav.home": "Home",
  "nav.spreadsheet": "Spreadsheet",
  "nav.shopGuide": "Shopping Guide",
  "nav.guide": "Guide",
  "nav.review": "Review",
  "nav.language": "Language",

  // Hero
  "hero.eyebrow": "THE ALLCHINABUY RESOURCE HUB",
  "hero.h1": "AllChinaBuy Spreadsheet — Discover Products, Finds & Buying Guides",
  "hero.subtitle": "Explore the latest AllChinaBuy spreadsheet resources, product finds, seller information, QC guides, shipping tips and practical buying advice — all organized in one place.",
  "hero.cta1": "Explore AllChinaBuy Spreadsheet",
  "hero.cta2": "Buy It Now",
  "hero.trust": "Independent resource • Updated regularly • Multilingual",

  // Categories
  "categories.title": "Popular AllChinaBuy Finds",
  "categories.select": "Select a Category",
  "categories.shoes": "Shoes",
  "categories.hoodies": "Hoodies/Sweaters",
  "categories.tshirts": "T-Shirts",
  "categories.jackets": "Jackets",
  "categories.pants": "Pants/Shorts",
  "categories.headwear": "Headwear",
  "categories.sets": "Sets",
  "categories.underwear": "Underwear/Underpants",
  "categories.jersey": "Jersey",
  "categories.accessories": "Accessories",
  "categories.bags": "Bags",
  "categories.belts": "Belts",
  "categories.perfumes": "Perfumes",
  "categories.other": "Other Stuff",
  "categories.viewAll": "View All Categories",

  // What is section
  "whatis.h2": "What Is the AllChinaBuy Spreadsheet?",
  "whatis.text": "The AllChinaBuy spreadsheet is a convenient way to organize product finds, categories, seller information and useful buying resources. Instead of searching through scattered pages, our resource hub brings important information together in a clear, searchable format.",
  "whatis.cta": "Explore the Spreadsheet",

  // Why use section
  "whyuse.h2": "Everything You Need to Research AllChinaBuy",
  "whyuse.card1.title": "Find Products Faster",
  "whyuse.card1.text": "Organized resources make product discovery easier.",
  "whyuse.card2.title": "Compare Options",
  "whyuse.card2.text": "Use tables and category guides to compare important factors.",
  "whyuse.card3.title": "Understand QC",
  "whyuse.card3.text": "Learn what QC photos can and cannot tell you.",
  "whyuse.card4.title": "Understand Shipping",
  "whyuse.card4.text": "Explore shipping-related guides before placing an order.",
  "whyuse.card5.title": "Research Before Buying",
  "whyuse.card5.text": "Use independent information to make better-informed decisions.",

  // Articles section
  "articles.h2": "Latest AllChinaBuy Guides & Updates",
  "articles.readMore": "Read Guide",
  "articles.viewAll": "View All Articles",

  // Trust section
  "trust.h2": "Independent Information Before You Buy",
  "trust.text": "allchinabuyspread.monster is an independent informational resource. We are not the official AllChinaBuy website unless explicitly stated. Always verify current prices, shipping options, policies and product information before making a purchase.",
  "trust.cta": "Read Our Safety Guide",

  // Final CTA
  "finalcta.h2": "Ready to Explore the AllChinaBuy Spreadsheet?",
  "finalcta.text": "Start with the spreadsheet, explore popular finds, compare useful resources and continue to the main website when you're ready to shop.",
  "finalcta.cta1": "Explore AllChinaBuy Spreadsheet",
  "finalcta.cta2": "Buy It Now",

  // Footer
  "footer.about": "About",
  "footer.policy": "Editorial Policy",
  "footer.contact": "Contact",
  "footer.disclaimer": "This website is an independent informational resource and is not affiliated with AllChinaBuy unless explicitly stated.",
  "footer.copyright": "© 2026 allchinabuyspread.monster. All rights reserved.",

  // Article 1
  "article1.title": "AllChinaBuy Spreadsheet 2026: Products, Finds & Buying Guide",
  "article1.summary": "The complete guide to understanding AllChinaBuy spreadsheets, product categories, and how to find the best deals in 2026.",
  "article1.date": "Updated August 2026",
  "article1.h1": "AllChinaBuy Spreadsheet 2026: Products, Finds & Buying Guide",
  "article1.intro": "The AllChinaBuy spreadsheet has become an essential resource for anyone exploring products from China through the AllChinaBuy platform. In this comprehensive guide, we cover everything you need to know about the spreadsheet system, how to navigate it, and how to make the most of your buying experience.",
  "article1.whatis.title": "What Is the AllChinaBuy Spreadsheet?",
  "article1.whatis.text": "The AllChinaBuy spreadsheet is a structured collection of product finds, seller information, and buying resources organized into categories. It helps buyers discover popular items, compare options, and make informed decisions without spending hours searching individual listings. The spreadsheet format allows for quick scanning, filtering by category, and tracking of product updates.",
  "article1.howto.title": "How to Use the AllChinaBuy Spreadsheet",
  "article1.howto.text": "Using the AllChinaBuy spreadsheet is straightforward. Start by selecting your product category from the dropdown menu. Each category contains curated finds with links to the original listings. Review the product details, check seller information, and compare prices before making a decision. Remember to always verify current prices and availability directly on the AllChinaBuy platform before purchasing.",
  "article1.categories.title": "Popular Product Categories",
  "article1.categories.text": "The AllChinaBuy spreadsheet covers a wide range of product categories including shoes, hoodies, T-shirts, jackets, pants, accessories, bags, and more. Each category is regularly updated with new finds and trending items. The most popular categories include streetwear, sneakers, and fashion accessories, which consistently receive high engagement from buyers worldwide.",
  "article1.qc.title": "Understanding QC and Quality Control",
  "article1.qc.text": "Quality Control (QC) photos are a critical part of the buying process. The AllChinaBuy spreadsheet often includes notes about QC expectations for different product categories. When ordering, always request QC photos to verify product quality before shipment. Learn what to look for in QC photos, including stitching details, material quality, and overall craftsmanship.",
  "article1.shipping.title": "Shipping and Warehouse Guide",
  "article1.shipping.text": "Shipping is a key consideration when buying through AllChinaBuy. The spreadsheet includes helpful information about shipping costs, delivery times, and warehouse options. Different shipping lines offer varying speeds and prices. Understanding volumetric weight, package consolidation, and insurance options can help you save money and avoid unexpected costs.",
  "article1.safety.title": "Safety and Trust Considerations",
  "article1.safety.text": "Before making any purchase, it is important to research the seller and verify product authenticity. The AllChinaBuy spreadsheet provides seller information, but buyers should always exercise caution. Check seller reviews, verify product photos, and start with smaller orders to test reliability. Never share personal payment information outside the official platform.",
  "article1.faq.title": "Frequently Asked Questions",
  "article1.faq1.q": "What is AllChinaBuy?",
  "article1.faq1.a": "AllChinaBuy is a shopping platform that connects international buyers with products from China. It offers access to a wide range of items including fashion, electronics, and accessories.",
  "article1.faq2.q": "Is the AllChinaBuy spreadsheet free?",
  "article1.faq2.a": "Yes, most AllChinaBuy spreadsheet resources are freely available to help buyers discover products and compare options.",
  "article1.faq3.q": "How often is the spreadsheet updated?",
  "article1.faq3.a": "Spreadsheet updates vary by resource. Some are updated weekly, while others may be updated monthly or as new products become available.",
  "article1.faq4.q": "Can I trust the sellers in the spreadsheet?",
  "article1.faq4.a": "Seller trustworthiness varies. Always do your own research, check reviews, and start with small test orders before making larger purchases.",
  "article1.cta": "Visit AllChinaBuy Spreadsheet",
  "article1.backToHome": "Back to Home",
  "article1.relatedArticles": "Related Articles",
  "article1.related1": "AllChinaBuy Review 2026",
  "article1.related2": "AllChinaBuy Shipping Guide",
  "article1.related3": "Is AllChinaBuy Legit?",
};